jQuery(document).ready(function ($) {
  // Check if chatgptAnalyzer is available (localized by enqueue function)
  // Silently return if not available (not on report builder page)
  if (typeof chatgptAnalyzer === "undefined") {
    return;
  }

  $("#analyze-button").on("click", function () {
    var $button = $(this);
    var dataToSend = $("#data-input").val().trim();

    // Validate input
    if (!dataToSend) {
      $("#result").html(
        '<p class="error">Please enter some data to analyze.</p>'
      );
      return;
    }

    // Disable button during request
    $button.prop("disabled", true).text("Analyzing...");
    $("#result").html("<p>Analyzing...</p>");

    $.ajax({
      url: chatgptAnalyzer.ajaxurl,
      type: "POST",
      data: {
        action: "analyze_with_chatgpt",
        nonce: chatgptAnalyzer.nonce,
        data: dataToSend,
      },
      success: function (response) {
        if (response.success) {
          $("#result").html(
            '<div class="analysis">' + response.data.analysis + "</div>"
          );
        } else {
          $("#result").html(
            '<p class="error">Error: ' +
              (response.data.message || "Unknown error occurred") +
              "</p>"
          );
        }
      },
      error: function (xhr, status, error) {
        $("#result").html(
          '<p class="error">Request failed. Please try again.</p>'
        );
        console.error("ChatGPT Analyzer Error:", error);
      },
      complete: function () {
        // Re-enable button
        $button.prop("disabled", false).text("Analyze");
      },
    });
  });
});
